import React from 'react';
import PropTypes from 'prop-types';

import {Typography} from '../';
import {TextField as MUTextField, InputAdornment} from '@mui/material';

const TextField = (props) => {
  const [isInvalid, setIsInvalid] = React.useState(false);
  const [wasBlurred, setWasBlurred] = React.useState(false);
  const [errors, setErrors] = React.useState([]);
  const errorText = (
    <>
      {errors.map((error, i) => <Typography display={'block'} key={i} variant='caption' color={wasBlurred ? 'error' : undefined}>{error}</Typography>)}
    </>
  );

  const {
    value='',
    validation,
    onChange,
    icon: Icon,
    onBlur = () => {},
    helperText,
    ...textFieldProps
  } = {...props};


  const validate = (val) => {
    if (validation && validation.conditions && validation.update) {
      const newErrors = validation.conditions.filter(([tester, error]) => !tester(val)).map(([tester, error]) => error);

      const isValid = newErrors.length === 0;
      validation.update(isValid);
      setErrors(newErrors);
      setIsInvalid(!isValid);
    }
  };

  const onUpdate = (e) => {
    onChange(e.target.value);
    validate(e.target.value);
    if (validation?.touch) {
      validation.touch();
    }
  };

  let inputProps = {};
  if (Icon) {
    inputProps = {
      startAdornment: (
        <InputAdornment position="start">
          <Icon />
        </InputAdornment>
      ),
      ...(textFieldProps.InputProps || {}),
    };
  }

  return (
    <MUTextField
      value={value}
      variant={'outlined'}
      {...textFieldProps}
      InputProps={inputProps}
      onChange={onUpdate}
      onFocus={() => validate(value)}
      onBlur={() => {
        validate(value);
        setWasBlurred(true);
        onBlur();
      }}
      error={wasBlurred && isInvalid}
      helperText={isInvalid ? errorText : helperText}
    />
  );
};

TextField.propTypes = {
  value: PropTypes.any,
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
  onChange: PropTypes.func.isRequired,
  validation: PropTypes.object,
  icon: PropTypes.object,
};

export default TextField;
